import { Injectable } from '@angular/core';
import {Api} from '../utils';
import {PrintFormatEnum, PrintTypeEnum} from '@models/print.enum';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SnackBarComponent} from '@components/snackbar/snackbar.component';
import {MatSnackBar} from '@angular/material';
import 'rxjs/add/operator/map';

interface PrintResponse {
  data: any;
  errors?: any;
}

@Injectable()
export class BrowserPrintService {
  public printer = null;
  // public devices = [];
  private statusCommand = '~HQES';

  constructor(
    private http: HttpClient,
    private api: Api,
    private matSnackBar: MatSnackBar,
  ) {}

  setup () {
    // Get the default device from the application as a first step. Discovery takes longer to complete.
    BrowserPrint.getDefaultDevice('printer', (device) => {
      // Add device to list of devices and to html select element
      this.printer = device;

      // this.devices.push(device);

      /*
      // Discover any other devices available to the application
      BrowserPrint.getLocalDevices(function(deviceList) {
        for (let i = 0; i < deviceList.length; i++) {
          // Add device to list of devices and to html select element
          const device = deviceList[i];
          if (!this.selectedDevice || device.uid !== this.selectedDevice.uid) {
            this.devices.push(device);
            const option = document.createElement('option');
            option.text = device.name;
            option.value = device.uid;
            htmlSelect.add(option);
          }
        }

      }, function() {
        alert('Error getting local devices');
        }, 'printer');
      */
    }, function(error) {
      alert('Error getting local devices');
    });
  }

  printFreightDocsByConsignmentNumber(
    consignmentNumbers: string|string[],
    type: PrintTypeEnum = PrintTypeEnum.LABEL
  ) {
    this.setup();
    if (Array.isArray(consignmentNumbers)) {
      consignmentNumbers = consignmentNumbers.join();
    }

    if (consignmentNumbers === '') {
      return this.snackBar('Du måste välja minst en sändning.');
    }

    const params = new HttpParams()
      .set('consignment_number', String(consignmentNumbers))
      .set('type', String(type))
      .set('format', String(PrintFormatEnum.ZPL));

    const url = this.api.getUrl('documents/print') + '?' + params.toString();

    return this.print(url);
  }

  printFreightDocsByOrderId(
    id: number,
    type: PrintTypeEnum = PrintTypeEnum.LABEL
  ) {
    const params = new HttpParams()
      .set('type', String(type))
      .set('format', String(PrintFormatEnum.ZPL));

    const url = this.api.getUrl('documents/orders/' + id + '/print') + '?' + params.toString();

    return this.print(url);
  }

  print (url) {
    this.http.get(url, {responseType: 'json'}).subscribe((response: PrintResponse) =>  {
      this.snackBar('Documents are being printed, please wait.', false);
      const decoded = decodeURIComponent(atob(response.data));
      // const utf8 =  '\xef\xbb\xbf'; //UTF8 BOM!
      // const test = '^XA\nCI28';
      // const replaced = decoded.replace(/CI13/, 'CI33');
      // console.log(response.data);
      console.log(decoded);
      this.sendToPrinter(decoded);
    }, error => {
      this.snackBar('Could\'nt load ZPL file from server.');
    });
  }

  sendToPrinter(data) {
    if (this.printer) {
      this.printer.send(data, (function(complete) {
        this.snackBar('Printing successfully completed.', false);
      }).bind(this), (function(error) {
        this.snackBar('An error occurred when printing.');
      }).bind(this));
    } else {
      this.snackBar('No printer available.');
    }
  }

  test() {


    /*
    this.checkPrinterStatus((status) => {
      console.log('Printer status: ' + status);
      if (status == 'Ready to Print') {
        this.printer.send(data, () => {
          console.log('Print complete');
          alert('print complete!');
        }, (error) => {
          console.log('Printer error: ' + error);
          this.printerError(error);
        });
      } else {
        console.log('Printer status error: ' + status);
        this.printerError(status);
      }
    });
     */

    /*
    this.printer.send(data, undefined, (error) => {
      alert(error);
    });
    */
  }

  checkPrinterStatus(finishedFunction) {
    console.log('checking...');
    this.printer.sendThenRead((text) => {
      console.log('sendThenRead');
      const statuses = [];
      let isReady = false;
      const hasError = text.charAt(70);
      const media = text.charAt(88);
      const head = text.charAt(87);
      const pause = text.charAt(84);
      // check each flag that prevents printing
      if (hasError == '0') {
        isReady = true;
        statuses.push('Ready to Print');
      }

      switch (media) {
        case '1':
          statuses.push('Paper out');
          break;
        case '2':
          statuses.push('Ribbon Out');
          break;
        case '4':
          statuses.push('Media Door Open');
          break;
        case '8':
            statuses.push('Cutter Fault');
            break;
      }

      switch (head) {
        case '1':
          statuses.push('Printhead Overheating');
          break;
        case '2':
          statuses.push('Motor Overheating');
          break;
        case '4':
          statuses.push('Printhead Fault');
          break;
        case '8':
          statuses.push('Incorrect Printhead');
          break;
      }

      if (pause == '1') {
        statuses.push('Printer Paused');
      }

      if ((!isReady) && (statuses.length === 0)) {
        statuses.push('Error: Unknown Error');
      }

      //finishedFunction(statuses.join());
      },
      '~HQES', this.printerError
    );
  }

  printerError(error) {
    alert(error);
  }

  sendErrorCallback(error) {
    console.log('sendErrorCallback');
  }

  sendFinishedCallback(response) {
    console.log('sendFinishedCallback');
  }

  readErrorCallback(error)  {
    console.log('readErrorCallback');
  }

  readFinishedCallback(response) {
    console.log('readFinishedCallback');
  }

  private snackBar(text: string, isError: boolean = true): void {
    this.matSnackBar.openFromComponent(SnackBarComponent, {
      data: {
        error: isError,
        message: text
      },
      panelClass: 'snackbar-container',
      duration: 3000,
    });
  }

  private base64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/browser-print.service.ts